import React, { useEffect } from 'react';
import { Col, InputGroup, Row } from 'react-bootstrap';
import { SearchSVG } from '../../../../Member/img/GlobalSVG';

import useReportList from '../hooks/useReportList';
import TextInput from 'src/Components/GenericInputText/TextInput';
import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import useGenerateReport from '../hooks/useGenerateReport';

const ReportFilter = () => {
  const {
    CATEGORY_OPTIONS,
    DATE_OPTIONS,
    STATUS_OPTIONS,
    resetReportFilters,
    dispatch,
    setReportsFilter,
    filters,
    getReportListData,
    onSearchTextChange,
    searchText,
    setSearchText,
  } = useReportList();

  const { getReportCategoryAndName, generateReport } = useGenerateReport();

  useEffect(() => {
    if (filters?.category || filters?.date || filters?.status)
      getReportListData();
  }, [filters?.category, filters?.date, filters?.status]);

  useEffect(() => {
    if (filters?.searchText?.length > 2 || filters?.searchText?.length === 0)
      getReportListData();
  }, [filters?.searchText]);

  useEffect(() => {
    if (
      !filters?.category &&
      !filters?.date &&
      !filters?.status &&
      !filters?.searchText
    )
      setSearchText('');
  }, [filters?.category, filters?.date, filters?.status, filters?.searchText]);

  useEffect(() => {
    if (generateReport?.reportCategoryDropdownOptions?.length === 0)
      getReportCategoryAndName('CATEGORY');
  }, []);

  return (
    <div>
      <div className="reports-filter-container">
        <div className="container-offset">
          <Row className="row-container">
            <Col
              lg={3}
              md={3}
              sm={6}
              className="col-section first-section-devider"
            >
              <div>
                <TextInput
                  parentClassName="searchbox-parent-class"
                  append={
                    <InputGroup.Text>
                      <SearchSVG.SearchSVG className="primary-text-color" />
                    </InputGroup.Text>
                  }
                  inputProps={{
                    type: 'text',
                    placeholder: 'Search by Name',
                    className: 'searchbox-child-class',
                    value: searchText,
                    onChange: (e) => onSearchTextChange(e),
                    id: 'filterSearchText',
                  }}
                />
              </div>
            </Col>
            <Col
              lg={3}
              md={3}
              sm={6}
              className="col-section category-section-container"
            >
              <div>
                <AutoSuggestionSelectComponent
                  placeholder="Category"
                  options={generateReport?.reportCategoryDropdownOptions}
                  components={{ IndicatorSeparator: () => null }}
                  inputClassName="height-32"
                  value={filters?.category}
                  onChange={(event) => {
                    dispatch(setReportsFilter({ category: event }));
                  }}
                  isSearchable={false}
                />
              </div>
            </Col>
            <Col lg={2} md={2} sm={6} className="col-section">
              <div>
                <AutoSuggestionSelectComponent
                  placeholder="Generated On"
                  options={DATE_OPTIONS}
                  components={{ IndicatorSeparator: () => null }}
                  inputClassName="height-32"
                  value={filters?.date}
                  onChange={(event) => {
                    dispatch(setReportsFilter({ date: event }));
                  }}
                  isSearchable={false}
                />
              </div>
            </Col>
            <Col lg={2} md={2} sm={6} className="col-section">
              <div>
                <AutoSuggestionSelectComponent
                  placeholder="Status"
                  options={STATUS_OPTIONS}
                  components={{ IndicatorSeparator: () => null }}
                  inputClassName="height-32"
                  value={filters?.status}
                  onChange={(event) => {
                    dispatch(setReportsFilter({ status: event }));
                  }}
                  isSearchable={false}
                />
              </div>
            </Col>
            <Col className="col-section">
              <div className="reset-filter-container">
                <span onClick={() => resetReportFilters()}>Reset Filter</span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default ReportFilter;
